import { render, staticRenderFns } from "./ViewCallbackFacebook.vue?vue&type=template&id=6cc4c934&scoped=true&"
import script from "./ViewCallbackFacebook.vue?vue&type=script&lang=ts&"
export * from "./ViewCallbackFacebook.vue?vue&type=script&lang=ts&"
import style0 from "./ViewCallbackFacebook.vue?vue&type=style&index=0&id=6cc4c934&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc4c934",
  null
  
)

export default component.exports